import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UnterschriftDialogInput } from './unterschrift-dialog';

@Component({
    selector: 'kiene-unterschrift-dialog',
    templateUrl: './unterschrift-dialog.component.html',
    styleUrls: ['./unterschrift-dialog.component.scss'],
})
export class UnterschriftDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<UnterschriftDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public input: UnterschriftDialogInput,
    ) {}

    ngOnInit(): void {}

    setUnterschrift(pngBase64: string) {
        this.dialogRef.close(pngBase64);
    }
}
